import { Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { SimpleModalComponent } from 'ngx-simple-modal';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { ToastrService } from 'ngx-toastr';
import { DateTime } from 'luxon';

export interface PdfPreviewModal {
  content: string;
}

@Component({
  selector: 'app-html-content-modal',
  templateUrl: './pdf-preview-modal.component.html',
  styleUrls: ['./pdf-preview-modal.component.sass'],
  encapsulation: ViewEncapsulation.None,
})
export class PdfPreviewModalComponent
  extends SimpleModalComponent<PdfPreviewModal, boolean>
  implements PdfPreviewModal
{
  content!: string;

  @ViewChild('insertedHtml') insertedHtml!: ElementRef;

  constructor(private _toastr: ToastrService) {
    super();
  }

  print() {
    this.createPdf(this.insertedHtml.nativeElement, 'print');
  }

  save() {
    this.createPdf(this.insertedHtml.nativeElement, 'save');
  }

  createPdf(element: HTMLElement, mode: 'print' | 'save'): void {
    html2canvas(element, { scale: 3 }).then(canvas => {
      const doc = new jsPDF('p', 'px', 'a4');
      const width = doc.internal.pageSize.getWidth();
      const ratio = width / canvas.width;
      doc.addImage(canvas, 'PNG', 0, 0, width, canvas.height * ratio);
      if (mode === 'save') {
        let time = DateTime.now().toString();
        time = time.substr(0, 16);
        time = time.replace('T', '_');
        doc.save(`${time}_igazolas.pdf`);
        return;
      } else if (mode === 'print') {
        doc.autoPrint();
        // @ts-ignore
        window.open(doc.output('bloburl'));
        return;
      }
      this._toastr.error('Hiba a mentés során!');
    });
  }
}
